import { formatIsoDateShortDisplay } from "./subscriptionPeriodDate";

export const HIDE_EXPIRED_SUBSCRIPTION_ALERT_KEY =
  "hide_expired_subscription_alert";

export const ALERT_SHOW_MINE_ONLY_KEY = "alert_show_mine_only";

export function getDaysUntilExpiry(validity_date) {
  if (validity_date === null) {
    return "Не приобреталась";
  }
  const dt = new Date().getTime();
  const dt2 = new Date(validity_date).getTime();
  if (dt2 - dt < 0) {
    return "Истекла";
  }
  return Math.ceil((dt2 - dt) / (1000 * 60 * 60 * 24));
}

export function formatManagerName(manager) {
  if (manager === null || manager === undefined) {
    return { text: "менеджер не заполнен", muted: true };
  }
  const name = managerFioPlain(manager);
  if (!name) {
    return { text: "менеджер не заполнен", muted: true };
  }
  return { text: name, muted: false };
}

/** @returns {string} пустая строка если manager null/без имён */
export function managerFioPlain(manager) {
  if (manager === null || manager === undefined) {
    return "";
  }
  return [manager.first_name, manager.last_name, manager.father_name]
    .filter(Boolean)
    .join(" ");
}

export function resolveManagerForSubscriptionItem(item, companys) {
  const fromRel = item.company_rel?.manager;
  if (fromRel) {
    return formatManagerName(fromRel);
  }
  const inn = item.company_rel?.inn;
  if (inn && Array.isArray(companys)) {
    const company = companys.find((c) => String(c.inn) === String(inn));
    if (company?.manager) {
      return formatManagerName(company.manager);
    }
  }
  return formatManagerName(null);
}

/**
 * @param {object} item
 * @param {Array|null} companys
 * @param {string|number|null|undefined} userId
 */
function isManagerIdMatch(manager, userId) {
  if (manager?.id == null || userId == null || userId === "") return false;
  return String(manager.id) === String(userId);
}

function isCompanyManagersMatchToUser(company, userId) {
  if (!company || userId == null || userId === "") return false;
  return (
    isManagerIdMatch(company.manager, userId) ||
    isManagerIdMatch(company.support_manager, userId)
  );
}

export function isSubscriptionAssignedToUser(item, companys, userId) {
  if (userId == null || userId === "") return false;
  const rel = item?.company_rel;
  if (rel && isCompanyManagersMatchToUser(rel, userId)) {
    return true;
  }
  const inn = rel?.inn;
  if (inn && Array.isArray(companys)) {
    const company = companys.find((c) => String(c.inn) === String(inn));
    if (company && isCompanyManagersMatchToUser(company, userId)) {
      return true;
    }
  }
  return false;
}

/**
 * @param {Array} list
 * @param {{ showMineOnly?: boolean, hideExpired?: boolean, searchQuery?: string, currentUserId?: string|number, companys?: Array|null }} options
 */
export function filterSubscriptionAlerts(list, options = {}) {
  if (!Array.isArray(list)) {
    return [];
  }
  let result = list;
  const {
    hideExpired,
    showMineOnly,
    searchQuery = "",
    currentUserId,
    companys,
  } = options;

  if (hideExpired) {
    result = result.filter(
      (item) => getDaysUntilExpiry(item.validity_date) !== "Истекла",
    );
  }
  if (showMineOnly) {
    result = result.filter((item) =>
      isSubscriptionAssignedToUser(item, companys, currentUserId),
    );
  }
  if (searchQuery.length > 1) {
    const q = searchQuery.toLowerCase();
    result = result.filter((item) => {
      const inn = String(item.company_rel?.inn ?? "").toLowerCase();
      const name = String(item.company_rel?.name_company ?? "").toLowerCase();
      const manager = resolveManagerForSubscriptionItem(item, companys);
      const fio = manager.muted ? "" : manager.text.toLowerCase();
      return inn.includes(q) || name.includes(q) || (fio && fio.includes(q));
    });
  }
  return result;
}

/** @param {string|null|undefined} validity_date */
export function formatValidityDate(validity_date) {
  return formatIsoDateShortDisplay(validity_date);
}
